import React from 'react'

function Footer(props) {
    return (
        <footer>
            <p>Powered by <a href='https://pokemontcg.io/'>Pokemon TCG API</a></p>
            <p>This website is not produced, endorsed, supported, or affiliated with Nintendo or The Pokémon Company.</p>
        </footer>
    )
}

export default Footer